import React from 'react';

import LogoImg from '@assets/svg/logo-gray.svg';
import WarningImg from '@assets/svg/warning.svg';

import {
  Overlay,
  Container,
  Header,
  Logo,
  Divider,
  Alert,
  Title,
  Description,
  Button,
  Row,
} from './StudioExpiredAlert.styles';

const StudioExpiredAlert = () => {
  return (
    <Overlay>
      <Container>
        <Header>
          <Row>
            <Logo src={LogoImg} alt="Logo" />
          </Row>

          <Divider />

          <Alert src={WarningImg} alt="Warning Sign" />

          <Title>Sorry, your studio has expired.</Title>

          <Description>
            Please click below to request an extended trial or upgrade options.
            A customer success manager will reach out to you shortly.
          </Description>

          <Button>Request help</Button>
        </Header>
      </Container>
    </Overlay>
  );
};

export { StudioExpiredAlert };
